import { FormField } from '@/global/components/Form'
import { Link } from '@/global/components/Link'
import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useStore } from '@/store'
import { z } from 'zod'

interface IProps {
    onClose: () => any
    onSubmit: (justificativa: string) => Promise<any>
    isLoading: boolean
}

export default function ModalJustificativaRegistro({
    onClose,
    onSubmit,
    isLoading,
}: IProps) {
    const empresa = useStore(state => state.company)

    return (
        <Dialog.Root
            open
            loading={isLoading}
            onClose={onClose}
            schema={z.object({
                justificativa: z
                    .string()
                    .trim()
                    .min(1, 'Insira uma justificativa')
                    .max(190),
            })}
            onSubmit={({ justificativa }) => onSubmit(justificativa)}
            height="auto"
            width="auto"
        >
            <Dialog.Title>
                Insira uma justificativa para a inclusão do registro
            </Dialog.Title>
            <Dialog.Content dividers>
                <FormField
                    name="justificativa"
                    label="Justificativa"
                    rows={5}
                    multiline
                    min={1}
                    max={190}
                    required
                    autoFocus
                />
                {hasPermission(['update', 'Empresas'], () => (
                    <span className="text-sm">
                        Não quer inserir uma justificativa toda vez?
                        <br />
                        Você pode definir uma justificativa padrão nas{' '}
                        <Link
                            href={`/cadastros/empresas/${empresa?.id}/editar?aba=ponto#justificativaPadraoRegistro`}
                        >
                            configurações da empresa
                        </Link>
                        .
                    </span>
                ))}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
